export const numberWithCommas = (x: number) => {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const nFormatter = (x: number) => {
  if (x < 1000) {
    return x.toFixed(2);
  }

  if (x < 1000000) {
    return parseFloat((x / 1000).toString()).toFixed(0) + 'K';
  }

  return parseFloat((x / 1000000).toString()).toFixed(1) + 'M';
};

export const commaStringToNumber = (str: string) => {
  return parseFloat(str.replace(/,/g, ''));
};

export const capitalizeString = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const numToPercent = (x: number) => {
  if (x === null || x === undefined || isNaN(x)) {
    return '';
  }
  return parseFloat((x * 100).toString()).toFixed(1) + '%';
};

export const formatPercent = (x: number) => {
  if (x === null || x === undefined || isNaN(x)) {
    return '';
  }
  return parseFloat(x.toString()).toFixed(1) + '%';
};

export const getNameById = (payload: {
  arrayData?: Array<{
    id: number;
    name: string;
  }>;
  id: number;
}) => {
  const { arrayData, id } = payload;

  if (arrayData && arrayData.length > 0) {
    const result = arrayData.find(item => id === item.id);

    return result ? result.name : 'No name';
  }

  return 'No name';
};

export const getFullLocationString = (data: any) => {
  if (data) {
    const { address, city, state, zipcode } = data;
    let locationString = '';

    if (address) {
      locationString = address;
    }

    if (city) {
      locationString = `${locationString ? `${locationString}, ` : ''} ${city}`;
    }

    if (state) {
      locationString = `${
        locationString ? `${locationString}, ` : ''
      } ${state}`;
    }

    if (zipcode) {
      locationString = `${
        locationString ? `${locationString}, ` : ''
      } ${zipcode}`;
    }

    return locationString;
  }

  return '';
};

export const monthDiff = (d1: number, d2: number) => {
  let months;
  const dt1 = new Date(d1);
  const dt2 = new Date(d2);

  months = (dt2.getFullYear() - dt1.getFullYear()) * 12;
  months -= dt1.getMonth();
  months += dt2.getMonth();

  return months;
};

export const toTitleCase = (str: string) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
